import { BASE_URL, BASE_URL_DEV } from "../_constants/urlConstants";
const { buildErrResponse } = require("../_utils/utils");
const { default: Axios } = require("axios");

export const MovileService = {
  createMovileProduct,
  getAllMoviles,
  getAllMovilesByCodeBar,
  getAllMovilesByParams,
  getMovileByParams,
  getMovileByParamsWithPagination,
  getMovileByBrandModel,
  getMovileById,
  getMovileByImei,
  getMovileByBrand,
  getMovilesByBarCodeWithPagination,
  updateBulkMoviles,
  updateAvailableStatus,
  updateMovile,
  updateMovilePrices,
  deleteMovileById,
};

function createMovileProduct(body) {
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/movile`, body)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAllMoviles() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/movile`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAllMovilesByCodeBar(barCode) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/movile/by-barcode?barCode=${barCode}`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAllMovilesByParams(queryParams) {
  const { barCode, siteId, imeiCode, inDistribution } = queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/movile/by-params`, {
      params: {
        barCode,
        siteId,
        imeiCode,
        inDistribution,
      },
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getMovileByParams(queryParams) {
  const { barCode, siteId, imeiCode, inDistribution } = queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/movile/one-by-params`, {
      params: {
        barCode,
        siteId,
        imeiCode,
        inDistribution,
      },
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getMovileByParamsWithPagination(queryParams) {
  const { brand, model, siteId, page, limit } = queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/movile/by-params/pagination`, {
      params: {
        brand,
        model,
        siteId,
        page,
        limit,
      },
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getMovileByBrandModel({ brand, model }) {
  return new Promise((resolve, reject) => {
    Axios.get(
      `${BASE_URL_DEV}/movile/brand-model?brand=${brand}&model=${model}`
    )
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getMovileById(id) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/movile/id?id=${id}`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
function getMovileByImei(imei) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/movile/imei?imei=${imei}`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
function getMovileByBrand(brand) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/movile/brand?brand=${brand}`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getMovilesByBarCodeWithPagination(body) {
  const { page, limit } = body;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/movile/by-barcode/pagination`, {
      params: {
        page,
        limit,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateBulkMoviles(body) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/movile`, body)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateAvailableStatus(imeiArray) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/movile/available-status`, imeiArray)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateMovile(id, body) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/movile/id?id=${id}`, body)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateMovilePrices(movileArray, movileParams) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/movile/prices`, {
      movileParams,
      movileArray,
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function deleteMovileById(id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`${BASE_URL_DEV}/movile/id?id=${id}`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
